// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3SsvY","active":"NavigationItem_active__hZ4Ju"};